import { endpoint } from "../../common/constant";
import { fetchAllPromisedData } from "../../common/utils/methods/commonMethods/utilityMethod";

export const createSuccessMsg = "New Academic phase added successfully.";
export const updateSuccessMsg = "Academic phase updated successfully.";

export const initialFilters = {
  phaseName: "",
  academicGroup: [],
  crct: [],
  status: "",
  fromDate: "",
  toDate: "",
};

export const academicGroup = [
  { label: "SOF", value: "SOF" },
  { label: "SOM", value: "SOM" },
  { label: "SOE", value: "SOE" },
];

export const phaseStatus = [
  { label: "Active", value: "ACTIVE" },
  { label: "Inactive", value: "INACTIVE" },
];

export const phaseDropdown = [
  {
    label: "Phase-01",
    value: "Phase-01",
  },
  {
    label: "Phase-02",
    value: "Phase-02",
  },
  {
    label: "Phase-03",
    value: "Phase-03",
  },
  {
    label: "Phase-04",
    value: "Phase-04",
  },
  {
    label: "Phase-05",
    value: "Phase-05",
  },
  {
    label: "Phase-06",
    value: "Phase-06",
  },
  {
    label: "Phase-07",
    value: "Phase-07",
  },
  {
    label: "Phase-08",
    value: "Phase-08",
  },
];

export const getCrctDropdown = async () => {
  const res = await fetchAllPromisedData(
    `${endpoint?.phaseConfiguration.getAllActiveCourseCategory}`
  );

  if (res.length) {
    const options = res.map((item) => ({
      label: `${item.courseAttributeValueDispValue} - ${item.courseAttributeValueDesc}`,
      value: item.courseAttributeValueDispValue,
    }));

    return options;
  }

  return [];
};

export const structureList = (crctDropdown, apiResponse) =>
  apiResponse.map((list) => ({
    ...list,
    phaseName: phaseDropdown.filter((item) => item.value === list.phaseName)[0],
    academicGroup: { label: list.academicGroup, value: list.academicGroup },
    crct: crctDropdown.filter((item) => item.value === list.crct)[0],
  }));

export const newRow = () => ({
  phaseName: "",
  academicGroup: "",
  crct: "",
  fromDate: '',
  toDate: '',
  status: "ACTIVE",
});
